import React from 'react';
import { useLocation } from 'react-router-dom';

const cardDataByPath = {
  '/BuildDocmentation': [
    {
      id: 1,
      iconSrc: "assets/img/leo/icons/12.png",
      title: 'Pricing, Proposal & Scheduling',
      description: '\
      After obtaining project details, we generate and deliver a proposal within one business day. Upon approval, we provide a comprehensive schedule outlining the site visit, drawing process, and expected delivery date.',
    },
    {
        id: 2,
        iconSrc: "assets/img/leo/icons/10.png",
        title: 'Site Visit & Drafting',
        description: 'We plan and conduct field studies, tailoring our approach to projects of varying complexity. Our drafters then create precise As-Built plans in your preferred format, considering specific customer requirements and project deliverables',
      },
      {
        id: 3,
        iconSrc: "assets/img/leo/icons/7.png",
        title: 'Quality Check & Delivery',
        description: 'Our QA team meticulously reviews As-Built drawings, models, and photos for accuracy. Upon completion, your project manager shares the final project files, including AutoCAD/Revit files, PDF plans, and digital images, via email or file share.',
      },
      {
        id: 4,
        iconSrc: "assets/img/leo/icons/9.png",
        title: 'Post-project Support',
        description: 'We stay in touch with you after delivering your plans. Throughout the entire lifecycle of your project and beyond, our staff is always accessible to discuss any inquiries or supplementary requirements.',
      },
  ],
  '/PointCloudModeling': [
    {
      id: 1,
      iconSrc: "assets/img/leo/icons/11.png",
      title: 'Reviewing input files',
      description: 'It is necessary to review the input files, which consist of scans and point cloud data',
    },
    {
        id: 2,
        iconSrc: "assets/img/leo/icons/8.png",
        title: 'Fixing orientation',
        description: 'To fix the orientation and new location of the point cloud, the coordinate equivalent of the scans are inserted. Work in the original coordinate system can be made easier by shifting base point.',
      },
      {
        id: 3,
        iconSrc: "assets/img/leo/icons/13.png",
        title: 'Preparing logical coordinate system',
        description: 'A logical coordinate system helps our modeling team produce in Revit accurate point cloud displays and desirable graphical behaviors. To quickly visualize point clouds, we apply sophisticated techniques and tools.',
      },
      {
        id: 4,
        iconSrc: "assets/img/leo/icons/1.png",
        title: 'Creating scan to BIM model',
        description: 'Our team used Revit to create Scan-to-BIM model at LOD 400 utilizing 3D survey measurements & photos. The deliverables improve insights for material estimation & renovation timeline.',
      },
   
  ],
  '/IndustrialScanningServices': [
    {
      id: 3,
      iconSrc: "assets/img/leo/icons/3.png",
      title: 'Creating scan to BIM model',
      description: 'Our team used Revit to create Scan-to-BIM model at LOD 400 utilizing 3D survey measurements & photos. The deliverables improve insights for material estimation & renovation timeline.',
    },
    // Add other cards specific to '/IndustrialScanningServices' path
  ],
  '/ConstructionScanningServices': [
    {
      id: 1,
      iconSrc: "assets/img/leo/icons/13.png",
      title: 'Planning and Preparation',
      description: 'The first step in the 3D laser scanning process is planning and preparation. This includes identifying the site to be scanned, determining the scanning equipment and methodology, and preparing the site for scanning.',
    },
    {
        id: 2,
        iconSrc: "assets/img/leo/icons/5.png",
        title: ' Scanning',
        description: 'The next step is to set up the laser scanner and begin scanning the site. The scanner emits a laser beam that measures distances and captures millions of data points, creating a highly detailed point cloud of the site.',
      },
      {
        id: 3,
        iconSrc: "assets/img/leo/icons/15.png",
        title: 'Registration',
        description: 'After scanning, the point cloud data is typically processed and registered to align the data from multiple scan positions and create a unified 3D model of the site.',
      },
      {
        id: 4,
        iconSrc: "assets/img/leo/icons/17.png",
        title: 'Post Processing',
        description: 'The point cloud data is then typically cleaned up and processed to remove any unwanted data, such as noise and artifacts, and to create a more accurate representation of the site.',
      },
      {
        id: 4,
        iconSrc: "assets/img/leo/icons/12.png",
        title: 'Analysis and Modeling',
        description: 'The processed point cloud data can then be used to create 3D models, maps, and drawings of the site, which can be used for a variety of purposes, including design, planning, and construction.',
      },
      {
        id: 4,
        iconSrc: "assets/img/leo/icons/7.png",
        title: 'Deliverables',
        description: 'Finally, the 3D models, maps, and drawings are typically delivered to the client in the desired format, such as CAD or BIM, for use in their project.',
      },
    // Add other cards specific to '/ConstructionScanningServices' path
  ],
  // Add other paths and their corresponding cards as needed
};

function InnerCards({title , paragraph}) {
  const location = useLocation();
  const path = location.pathname;

  const cardsData = cardDataByPath[path] || [];

  return (
    <div>
      <section className='section'>
        <div className='container'>
          <div className="section-title">
            <h2>
                {title}
            </h2>
            <p>
                {paragraph}
            </p>
          </div>

          <div className='row' style={{ display: 'flex', justifyContent: 'center' }}>
            {cardsData.map((card) => (
              <div key={card.id} className='col-md-3 splcards'>
                <div className="section_our_solution">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="our_solution_category">
                        <div className="solution_cards_box">
                          <div className="solution_card">
                            <div className="hover_color_bubble"></div>
                            <div className="so_top_icon">
                              <img src={card.iconSrc} alt="" />
                            </div>
                            <div className="solu_title">
                              <div><strong>{card.title}</strong></div>
                            </div>
                            <div className="solu_description">
                              <p>{card.description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default InnerCards;
